export function onExpand({ target }) {
    target.style.height = null;
    target.removeEventListener('transitionend', onExpand);
    // target.style.removeProperty('--max-height');
    target.classList.remove('_collapse-body_transition');
    target.classList.add('_active', '_collapse-body')
}
export function onCollapse({target}) {
    target.classList.remove('_collapse-body_transition');
    target.classList.add('_collapse-body');
    target.removeEventListener('transitionend', onCollapse);
}

export function reflow(el) {
    el.offsetHeight;
}